(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["price"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__priceFitInit) return;
    window.__priceFitInit = true;
    function fit(el) {
      var max = parseFloat(el.dataset.fitMax) || 18;
      var min = parseFloat(el.dataset.fitMin) || 12;
      var avail = el.clientWidth;
      if (!avail) return;
      var lo = min, hi = max, best = min;
      for (var i = 0; i < 9; i++) {
        var mid = (lo + hi) / 2;
        el.style.fontSize = mid + 'px';
        if (el.scrollWidth <= avail + 0.5) { best = mid; lo = mid; } else { hi = mid; }
      }
      el.style.fontSize = Math.floor(best * 4) / 4 + 'px';
    }
    var queued = false;
    function fitAll() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        document.querySelectorAll('[data-price-fit]').forEach(fit);
      });
    }
    window.addEventListener('resize', fitAll);
    document.addEventListener('DOMContentLoaded', fitAll);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitAll);
    window.addEventListener('load', fitAll);
    // Variant change: product-price.js replaces the price container -> refit
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var r = records[i];
        for (var j = 0; j < r.addedNodes.length; j++) {
          var n = r.addedNodes[j];
          if (n.nodeType === 1 && (n.matches('[data-price-fit]') || n.querySelector('[data-price-fit]'))) { fitAll(); return; }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
    fitAll();
  })();
  } catch(e) { console.error(e); }
})();

})();
